import {Directive, ElementRef, HostListener, inject} from '@angular/core';

/**
 * Gives a truncated tab label its full text as a native tooltip.
 *
 * A `.tabs` row is kept on one line (see the `.tabs` rule in `styles.scss`), so on a viewport too
 * narrow for every label the long ones are cut off with an ellipsis. The label is read from the
 * DOM on hover — that is late enough for the browser to pick the fresh `title` up before it shows
 * the tooltip, and it keeps the check to the one tab the user is pointing at, at the width it has
 * right then. Tabs that fit carry no `title`, so a label that is fully readable never pops up a
 * tooltip repeating it.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- class selector on purpose: it has to reach every row the global `.tabs` rule truncates, without each template opting in
  selector: '.tabs'
})
export class TabLabelTitleDirective {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('mouseover', ['$event.target'])
  onMouseOver(target: EventTarget | null): void {
    const tab = (target as Element)?.closest?.('.tab') as HTMLElement;
    if (!tab || !this.el.nativeElement.contains(tab)) {
      return;
    }
    const truncated = tab.scrollWidth > tab.clientWidth;
    if (truncated) {
      tab.title = tab.textContent.trim();
    } else {
      tab.removeAttribute('title');
    }
  }
}
